export enum ImportTypeEnum {
  'All' = 'All',
  'Config' = 'Config',
  'Triggers' = 'Triggers',
  'Modules' = 'Modules'
}
